module.exports = __webpack_public_path__ + "static/media/ic-profile.39c663bb.svg";